module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Huddersfield.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Huddersfield.png
// module id = 2187
// module chunks = 4